import { useMutation } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useFetchUserListBySovcomClientId = () => {

  const response = useMutation({
    mutationFn: ({ clientId }: { clientId: string }) => api.users.fetchUserListBySovcomClientId(clientId),

    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось получить список счетов по clientId',
        type: 'error',
      })
    },

  })

  const data = response.data?.accounts?.map((item: any) => {
    const { accounts, ...rest } = response.data

    return {
      ...rest,
      ...item
    }
  })

  return { ...response, data }
}
